//Local Storage Key
export const CAMPAIGN_POINTS_STEP = 'campaign_points_step';

// Action Types
export const SET_CAMPAIGN_STEP = 'SET_CAMPAIGN_STEP';

// States
export const CAMPAIGN_STEP_ENTRY = 'CAMPAIGN_STEP_ENTRY';
export const CAMPAIGN_STEP_RULE = 'CAMPAIGN_STEP_RULE';
export const CAMPAIGN_STEP_SIGNUP = 'CAMPAIGN_STEP_SIGNUP';
export const CAMPAIGN_STEP_POLICY = 'CAMPAIGN_STEP_POLICY';
export const CAMPAIGN_STEP_SUCCEED = 'CAMPAIGN_STEP_SUCCEED';
export const CAMPAIGN_STEP_WATCHED = 'CAMPAIGN_STEP_WATCHED';
export const CAMPAIGN_STEP_COMPLETE = 'CAMPAIGN_STEP_COMPLETE';
export const CAMPAIGN_STEP_REFUSED = 'CAMPAIGN_STEP_REFUSED';
export const CAMPAIGN_STEP_NONE = 'CAMPAIGN_STEP_NONE';


const allStates = Object.freeze([
  CAMPAIGN_STEP_ENTRY,
  CAMPAIGN_STEP_RULE,
  CAMPAIGN_STEP_SIGNUP,
  CAMPAIGN_STEP_POLICY,
  CAMPAIGN_STEP_SUCCEED,
  CAMPAIGN_STEP_WATCHED,
  CAMPAIGN_STEP_COMPLETE,
  CAMPAIGN_STEP_REFUSED,
  CAMPAIGN_STEP_NONE,
]);

// Action Creators
export function setCampaignStep(step) {
  return {
    type: SET_CAMPAIGN_STEP,
    payload: step,
  };
}

// Reducer
export default function reducer(state = CAMPAIGN_STEP_NONE, action) {
  return action.type === SET_CAMPAIGN_STEP && allStates.includes(action.payload) ? action.payload : state;
}
